import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

// Lazy load pages
const Home = lazy(() => import("../pages/Home"));
const About = lazy(() => import("../pages/About"));
const Contactus = lazy(() => import("../pages/Contactus"));

// Lazy load courses
const DIGITAL_MARKETING = lazy(() => import("../../Courses/DIGITAL_MARKETING"));
const FLUTTER = lazy(() => import("../../Courses/FLUTTER"));
const REACT = lazy(() => import("../../Courses/REACT"));
const REACT_NATIVE = lazy(() => import("../../Courses/REACT_NATIVE"));
const SOFTWARE_TESTING = lazy(() => import("../../Courses/SOFTWARE_TESTING"));
const ANDROID = lazy(() => import("../../Courses/ANDROID"));
const Playwrighttesting = lazy(() => import("../../Courses/Playwrighttesting"));
const IOS = lazy(() => import("../../Courses/IOS"));
const PHP = lazy(() => import("../../Courses/PHP"));
const PythonTraining = lazy(() => import("../../Courses/python"));
const CCppTraining = lazy(() => import("../../Courses/C_C++"));
const Java = lazy(() => import("../../Courses/Java"));
const FullStackCourse = lazy(() => import("../../Courses/fullStackCourse"));
const DataAnalyst = lazy(() => import("../../Courses/DATA_ANALYTICS"));
const AppiumTesting = lazy(() => import("../../Courses/Appiummobiletesting"));
const AIGenAI = lazy(() => import("../../Courses/AIGenAI"));
const ManualTestingQuestions = lazy(() => import("../../Tasks/ManualTestingQuestions"));
const ManualTestingPrograms = lazy(() => import("../../Tasks/ManualTestingPrograms"));

// Lazy load TS Tasks
const DailyTask = lazy(() => import("../../Tasks/ts_tasks/varibale_task"));
const ConditionStatTask = lazy(() => import("../../Tasks/ts_tasks/condition_st_task"));
const SwitchStatementTask = lazy(() => import("../../Tasks/ts_tasks/SwitchStatementTask"));
const LoopsTask = lazy(() => import("../../Tasks/ts_tasks/loopstask"));
const FunctionTypesTask = lazy(() => import("../../Tasks/ts_tasks/functions"));
const CollectionsTask = lazy(() => import("../../Tasks/ts_tasks/collections"));
const ClassObjectTask = lazy(() => import("../../Tasks/ts_tasks/class_object"));
const ConstructorTask = lazy(() => import("../../Tasks/ts_tasks/constructor"));
const InheritanceTask = lazy(() => import("../../Tasks/ts_tasks/inhertence"));
const AbstractClassTask = lazy(() => import("../../Tasks/ts_tasks/abstract"));
const InterfaceTasks = lazy(() => import("../../Tasks/ts_tasks/interface_task"));
const AsyncAwaitTasks = lazy(() => import("../../Tasks/ts_tasks/async_await_task"));

// Python Quizzes
const PythonTasks = lazy(() => import("../../Tasks/data_analy_task/python_task/routes/PythonTasks"));
const VariableQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/VariableQuiz"));
const ConditionalsQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/ConditionalsQuiz"));
const LoopsAndLogicalQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/LoopsAndLogicalQuiz"));
const WhileAndListsQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/WhileAndListsQuiz"));
const TuplesDictJsonQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/TuplesDictJsonQuiz"));
const FunctionsQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/FunctionsQuiz"));
const OOPBasicsQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/OOPBasicsQuiz"));
const InheritanceQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/InheritanceQuiz"));
const PolymorphismQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/PolymorphismQuiz"));
const DataLibrariesQuiz = lazy(() => import("../../Tasks/data_analy_task/python_task/DataLibrariesQuiz"));
const MySqlQuiz = lazy(() => import("../../Tasks/data_analy_task/mysql_task/MySqlQuiz"));
const ExcelQuiz = lazy(() => import("../../Tasks/data_analy_task/excel_task/excelquiz"));

// Playwright Tasks
const PlaywrightTasks = lazy(() => import("../../Tasks/PlaywrightTasks/routes/playwright_task_nav"));
const PlaywrightBasics = lazy(() => import("../../Tasks/PlaywrightTasks/Playwrights_basics"));
const UrlTitleValidationTasks = lazy(() => import("../../Tasks/PlaywrightTasks/UrlTitleValidation"));
const BrowserLaunchInputFill = lazy(() => import("../../Tasks/PlaywrightTasks/BrowserLaunchInputFill"));
const TextContentInputValueTasks = lazy(() => import("../../Tasks/PlaywrightTasks/TextContentInputValueTasks"));
const AlertTasks = lazy(() => import("../../Tasks/PlaywrightTasks/AlertTasks"));
const IframeTasks = lazy(() => import("../../Tasks/PlaywrightTasks/IframeTasks"));
const DropdownTasks = lazy(() => import("../../Tasks/PlaywrightTasks/DropdownTasks"));
const NormalXpathTasks = lazy(() => import("../../Tasks/PlaywrightTasks/NormalXpathTasks"));
const XpathAxesTasks = lazy(() => import("../../Tasks/PlaywrightTasks/XpathAxesTasks"));
const WindowHandleTasks = lazy(() => import("../../Tasks/PlaywrightTasks/WindowHandleTasks"));
const WebTableTasks = lazy(() => import("../../Tasks/PlaywrightTasks/WebTableTasks"));
const ReusableMethodsTasks = lazy(() => import("../../Tasks/PlaywrightTasks/ReusableMethodsTasks"));
const PageObjectModelTasks = lazy(() => import("../../Tasks/PlaywrightTasks/PageObjectModelTasks"));
const DataDrivenFrameworkTasks = lazy(() => import("../../Tasks/PlaywrightTasks/DataDrivenFrameworkTasks"));
const PlaywrightInterviewQuestions = lazy(() => import("../../Tasks/PlaywrightTasks/PlaywrightInterviewQuestions"));
const PdfViewer = lazy(() => import("../PdfViewer"));

const AppRoutes = () => {
  return (
    <Routes>
      {/* Pages */}
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contactus" element={<Contactus />} />

      {/* Courses */}
      <Route path="/digital_marketing" element={<DIGITAL_MARKETING />} />
      <Route path="/flutter" element={<FLUTTER />} />
      <Route path="/react" element={<REACT />} />
      <Route path="/react_native" element={<REACT_NATIVE />} />
      <Route path="/software_testing" element={<SOFTWARE_TESTING />} />
      <Route path="/android" element={<ANDROID />} />
      <Route path="/playwright_testing" element={<Playwrighttesting />} />
      <Route path="/playwright_testing/pdf/:pdfId" element={<PdfViewer />} />
      <Route path="/ios" element={<IOS />} />
      <Route path="/php" element={<PHP />} />
      <Route path="/apm" element={<PythonTraining />} />
      <Route path="/c_cpp" element={<CCppTraining />} />
      <Route path="/java" element={<Java />} />
      <Route path="/fullstack" element={<FullStackCourse />} />
      <Route path="/data_analytics" element={<DataAnalyst />} />
      <Route path="/appium_testing" element={<AppiumTesting />} />
      <Route path="/ai_gen_ai" element={<AIGenAI />} />
      <Route path="/manual_testing" element={<ManualTestingQuestions />} />
      <Route path="/manual_testing/programs" element={<ManualTestingPrograms />} />

      {/* TS Tasks */}
      <Route path="/variable_task" element={<DailyTask />} />
      <Route path="/conditionstattask" element={<ConditionStatTask />} />
      <Route path="/switchstatementtask" element={<SwitchStatementTask />} />
      <Route path="/loopstask" element={<LoopsTask />} />
      <Route path="/functiontypestask" element={<FunctionTypesTask />} />
      <Route path="/collectionstask" element={<CollectionsTask />} />
      <Route path="/classobjecttask" element={<ClassObjectTask />} />
      <Route path="/constructortask" element={<ConstructorTask />} />
      <Route path="/inheritancetask" element={<InheritanceTask />} />
      <Route path="/abstractclasstask" element={<AbstractClassTask />} />
      <Route path="/interface_task" element={<InterfaceTasks />} />
      <Route path="/async_await_task" element={<AsyncAwaitTasks />} />

      {/* Python Quizzes */}
      <Route path="/pythontasks" element={<PythonTasks />} />
      <Route path="/python-quiz/variables" element={<VariableQuiz />} />
      <Route path="/python-quiz/conditionals" element={<ConditionalsQuiz />} />
      <Route path="/python-quiz/loops" element={<LoopsAndLogicalQuiz />} />
      <Route path="/python-quiz/lists" element={<WhileAndListsQuiz />} />
      <Route path="/python-quiz/data-structures" element={<TuplesDictJsonQuiz />} />
      <Route path="/python-quiz/functions" element={<FunctionsQuiz />} />
      <Route path="/python-quiz/oop-basics" element={<OOPBasicsQuiz />} />
      <Route path="/python-quiz/inheritance" element={<InheritanceQuiz />} />
      <Route path="/python-quiz/polymorphism" element={<PolymorphismQuiz />} />
      <Route path="/python-quiz/data-libraries" element={<DataLibrariesQuiz />} />
      <Route path="/mysql-quiz" element={<MySqlQuiz />} />
      <Route path="/excel-quiz" element={<ExcelQuiz />} />

      {/* Playwright Tasks */}
      <Route path="/playwright_tasks" element={<PlaywrightTasks />} />
      <Route path="/playwright_testing/basics" element={<PlaywrightBasics />} />
      <Route path="/playwright_testing/url-title-validation" element={<UrlTitleValidationTasks />} />
      <Route path="/playwright_testing/browser-launch-input-fill" element={<BrowserLaunchInputFill />} />
      <Route path="/playwright_testing/text-content-input-value" element={<TextContentInputValueTasks />} />
      <Route path="/playwright_testing/alerts" element={<AlertTasks />} />
      <Route path="/playwright_testing/iframe" element={<IframeTasks />} />
      <Route path="/playwright_testing/dropdown" element={<DropdownTasks />} />
      <Route path="/playwright_testing/normal-xpath" element={<NormalXpathTasks />} />
      <Route path="/playwright_testing/xpath-axes" element={<XpathAxesTasks />} />
      <Route path="/playwright_testing/window-handle" element={<WindowHandleTasks />} />
      <Route path="/playwright_testing/web-table" element={<WebTableTasks />} />
      <Route path="/playwright_testing/reusable-methods" element={<ReusableMethodsTasks />} />
      <Route path="/playwright_testing/page-object-model" element={<PageObjectModelTasks />} />
      <Route path="/playwright_testing/data-driven-framework" element={<DataDrivenFrameworkTasks />} />
      <Route path = "/playwright_testing/PlaywrightInterviewQuestions" element = {<PlaywrightInterviewQuestions />} />
    </Routes>
  );
};

export default AppRoutes;
